/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['backbone', 'underscore', 'assets/js/modules/widgets/mailingLists/mailingListItemCollection'], function(
    backbone,
    _,
    MailingListItemCollection
) {
    var MailingListModel;

    return (MailingListModel = backbone.Model.extend(
        {
            defaults: {
                token: null,
                name: 'List 01',
                records: 0,
                created: null,
                addCurrentResident: false,
                deleted: false,

                currentRecords: 0,
                editedItemIds: [],
                removedItemIds: [],
                pagesLoaded: [],

                saveCallback: null,
                replaceMode: false,

                itemsCollection: new MailingListItemCollection([])
            },

            initialize: function() {
                this.set('currentRecords', this.get('records'));
                this.set('itemsCollection', new MailingListItemCollection([]));
            },

            toDTO: function(options) {
                var _this = this;
                var dto = {};
                var attribute;

                _.each(MailingListModel.toDTOMap, function(mappedName, attributeName) {
                    attribute = _this.get(attributeName);
                    if (attribute !== undefined) {
                        if (attribute === '') {
                            attribute = null;
                        }
                        dto[mappedName] = attribute;
                    }
                });

                return _.clone(dto);
            },

            /**
             * @param {Object} options
             * @returns {MailingListModel}
             */
            fromDTO: function(options) {
                var _this = this;
                _.each(MailingListModel.fromDTOMap, function(mappedName, attributeName) {
                    if (options[mappedName] !== undefined) {
                        _this.set(attributeName, options[mappedName]);
                    }
                });
                this.set('currentRecords', this.get('records'));
                return this;
            },

            // clear list after switching to another one to save some memory
            clearList: function() {
                this.set('itemsCollection', new MailingListItemCollection([]));
                this.set('currentRecords', this.get('records'));
                this.set('editedItemIds', []);
                this.set('removedItemIds', []);
                this.set('pagesLoaded', []);
                this.set('replaceMode', false);
            }
        },
        {
            fromDTOMap: {
                token: 'token',
                name: 'name',
                records: 'records',
                created: 'created',
                addCurrentResident: 'add_current_resident'
            },
            toDTOMap: {
                token: 'token',
                name: 'name',
                addCurrentResident: 'add_current_resident'
            },
            MAX_ITEMS_LENGTH: 100000
        }
    ));
});
